import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import type { MailSettings, UpdateMailSettingsInput } from '@catalyst-psa/shared';

import { api } from '../../api/client.js';

const mailKeys = {
  settings: ['mail', 'settings'] as const,
};

export function useMailSettings(): UseQueryResult<MailSettings> {
  return useQuery({
    queryKey: mailKeys.settings,
    queryFn: () => api.get<MailSettings>('/mail/settings'),
  });
}

export function useUpdateMailSettings(): UseMutationResult<
  MailSettings,
  unknown,
  UpdateMailSettingsInput
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateMailSettingsInput) =>
      api.put<MailSettings>('/mail/settings', input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: mailKeys.settings });
    },
  });
}
